<template>
	<div id="content">
		<div class="wrapper">
			<h1>Abmeldung vom Reifentag-Newsletter</h1>
			<form v-if="!sent" @submit.prevent="false" style="max-width: 450px;">
				<label for="email">Ihre E-Mail-Adresse</label>
				<input v-model="email" type="email" name="email" id="email" />
				<button :disabled="email.length < 5" @click="submit">
					Abmelden
				</button>
			</form>
			<p v-else>
				Wir haben Ihre Anfrage erhalten, Sie werden keine zukünftigen Einladungen mehr erhalten.
			</p>
		</div>
		<transition>
			<div v-show="loading" class="loading-wrapper">
				<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
			</div>
		</transition>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Unsubscribe',
	data() {
		return {
			sent: false,
			email: '',
			loading: false,
		}
	},
	methods: {
		submit() {
			this.loading = true
			axios.post('https://api.carmarkt.net/reservations/unsubscribe', { email: this.email })
				.then(() => {
					this.sent = true
					this.loading = false
				})
				.catch(() => {
					this.loading = false
					alert('Bitte geben Sie eine gültige E-Mail-Adresse an.')
				})
		},
	},
}
</script>

<style lang="scss" scoped>
button {
	margin: 1rem 0;
	width: auto;

	&[disabled] {
		opacity: 0.5;
	}
}

.loading-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	background-color: rgba(255, 255, 255, 0.5);
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>

<style lang="scss">
#content {
	position: relative;
}

.lds-ring {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}

.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 32px;
	height: 32px;
	margin: 4px;
	border: 4px solid #b10a16;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #b10a16 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}

</style>
